import DOMPurify from 'dompurify';
import { useEffect } from "react";
import useSocialEmbed from './useSocialEmbed';

export const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export function formatToK(number) {
    let result = (number / 1000);

    if (Number.isInteger(result)) {
        return result + 'K';
    } else {
        return result.toFixed(1) + 'K';
    }
}

export const sha256 = async (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

export const slugify = (text) => {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

export const HtmlRenderer = ({ htmlContent }) => {
  useSocialEmbed(htmlContent);
  // useEffect(() => {
  //   // TikTok
  //   const tiktokScript = document.createElement("script");
  //   tiktokScript.src = "https://www.tiktok.com/embed.js";
  //   tiktokScript.async = true;
  //   document.body.appendChild(tiktokScript);

  //   // Instagram
  //   const igScript = document.createElement("script");
  //   igScript.src = "https://www.instagram.com/embed.js";
  //   igScript.async = true;
  //   document.body.appendChild(igScript);

  //   // Twitter/X
  //   const twScript = document.createElement("script");
  //   twScript.src = "https://platform.twitter.com/widgets.js";
  //   twScript.async = true;
  //   document.body.appendChild(twScript);
  // }, [htmlContent]);

  const cleanHTML = DOMPurify.sanitize(htmlContent, {
    ADD_TAGS: ["iframe", "img", "blockquote"],
    ADD_ATTR: [
      "src",
      "allow",
      "allowfullscreen",
      "frameborder",
      "alt",
      "cite",
      "style",
      "data-instgrm-permalink",
      "data-instgrm-version",
    ],
  });

  useEffect(() => {
    const embeds = document.querySelectorAll(".video-embed iframe");

    embeds.forEach((iframe) => {
      if (iframe.dataset.loaded) return;

      iframe.addEventListener("load", () => {
        iframe.dataset.loaded = "true";
        iframe.closest(".video-embed")?.classList.add("loaded");
      });
    });
  }, [htmlContent]);

  return (
    <div
      className="ql-render"
      dangerouslySetInnerHTML={{ __html: cleanHTML }}
    ></div>
  );
};
